import { render } from "./page-my-tariffs.vue?vue&type=template&id=2378b185&scoped=true"
import script from "./page-my-tariffs.vue?vue&type=script&lang=js"
export * from "./page-my-tariffs.vue?vue&type=script&lang=js"

import "./page-my-tariffs.vue?vue&type=style&index=0&id=2378b185&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2378b185"]])

export default __exports__